var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRmrk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.31 22.652h-1.876l-.107-.247a5.343 5.343 0 0 0-3.504-2.761 7.576 7.576 0 0 0 4.85-4h1.876a6.37 6.37 0 0 0 .565-2.548 11.43 11.43 0 0 0-.248-2.513C27.982 6.62 24.832 4 18.425 4H3.876v11.68H2v7.008h1.876v5.804h7.01v-5.804h5.309c2.548 0 3.15 1.663 4.99 5.769H30c-.991-2.265-2.3-4.955-2.69-5.805zM10.85 10.583h7.08c1.45 0 2.796 1.097 2.796 2.549 0 1.45-1.345 2.548-2.797 2.548h-7.08v-5.097z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmrk);
export default __webpack_public_path__ + "static/media/RMRK.7b99f66efad8a2e6f21973c423be6307.svg";
export { ForwardRef as ReactComponent };